module.exports = __webpack_public_path__ + "static/img/Solar_Community_Logo.14bcb1c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Solar_Community_Logo.svg
// module id = BbEy
// module chunks = 1